import * as d3 from 'd3';
import DayAxis from './DayAxis.js';
import WeekAxis from './WeekAxis.js';
import MonthAxis from './MonthAxis.js';
import QuarterAxis from './QuarterAxis.js';
import YearAxis from './YearAxis.js';
import RowMilestonesMarker from './RowMilestoneMarker.jsx';
import Modal from './Modal.js';

export default class MileMarkersChart {
  constructor(element, data, options) {
    this.element = element;
    this.data = data;
    this.options = options;
    this.components = [];
  }

  set data(data) {
    this._data = {
      milestonesFromAllCharts: data.milestonesFromAllCharts,
    };
  }

  get data() {
    return this._data;
  }

  update() {
    this.components.forEach((component) => component.update());
  }

  rebuild() {
    this.chart.remove();
    this.build();
  }

  buildComponents(components) {
    components.forEach((component, index) => {
      this.components[index] = new component({
        chart: this.chart,
        data: this.data,
        options: this.options,
        rows: this.rows,
      });
      this.components[index].build();
    });
  }

  build() {
    d3.select(this.element).selectAll('svg').remove(); // clearing previous

    const { width } = this.options;

    this.options.height = 25;
    this.chart = d3
      .select(this.element)
      .append('svg')
      .attr('class', 'chart miles-chart')
      .attr('width', width)
      .attr('height', this.options.height);
    const componentsToInclude = [];

    if (this.options.scaleType === 'week') {
      componentsToInclude.push(DayAxis);
      componentsToInclude.push(WeekAxis);
    }

    if (this.options.scaleType === 'month') {
      componentsToInclude.push(MonthAxis);
      componentsToInclude.push(WeekAxis);
    }

    if (this.options.scaleType === 'quarter') {
      componentsToInclude.push(MonthAxis);
      componentsToInclude.push(QuarterAxis);
    }

    if (this.options.scaleType === 'year') {
      componentsToInclude.push(QuarterAxis);
      componentsToInclude.push(YearAxis);
    }

    componentsToInclude.push(RowMilestonesMarker);
    componentsToInclude.push(Modal);

    this.buildComponents(componentsToInclude);
  }
}
